import React from 'react';
import PropTypes from 'prop-types';

const GenericSearch = ({
  searchItems,
  searchField,
  handleSearchResult,
  placeholder = 'Search...',
  optionName,
  propCode,
  propCodeDescription,
}) => {
  const handleSearch = event => {
    const re = /\s\s+/g;
    const searchTextArray = event.target.value
      .trim()
      .replace(re, ' ')
      .toLowerCase()
      .split(' ');
    const searchResult = searchItems.filter(item => {
      const text =
        optionName === 'PROP-CODE'
          ? item[propCodeDescription].concat(`(${item[propCode]})`).toLowerCase()
          : item[searchField].toLowerCase();
      return (
        searchTextArray.length === 0 ||
        searchTextArray.every(searchText => text.indexOf(searchText) > -1)
      );
    });
    handleSearchResult(searchResult);
  };

  return (
    <input type="text" placeholder={placeholder} onChange={handleSearch} />
  );
};

GenericSearch.propTypes = {
  searchItems: PropTypes.arrayOf(PropTypes.object),
  searchField: PropTypes.string,
  handleSearchResult: PropTypes.func,
  placeholder: PropTypes.string,
  optionName: PropTypes.string,
  propCodeDescription: PropTypes.string,
  propCode: PropTypes.string,
};

export default GenericSearch;
